<template>
  <div>
    <div class="error-numb">
      {{ code }}
    </div>
    <div class="page-wrapper">
      <div class="page-not-found-container">
        <div class="form">
          <div class="error-name">
            {{ name }}
          </div>
          <div class="error-text">
            {{ message }}
          </div>
          <div class="buttons">
            <button type="button" class="button" title="Назад" @click="redirect(code)">Назад</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',

  data () {
    return {
      code: '',
      name: '',
      message: ''
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('page-not-found')

    this.code = this.$route.params.code
    switch (this.code) {
      case '403':
        this.name = 'Недостаточно прав'
        this.message = 'У Вас недостаточно прав для просмотра или редактирования этой страницы.'
        break
      case '404':
        this.name = 'Страница не найдена'
        this.message = 'Возможно вы опечатались, или страница была удалена. ' +
            'Попробуйте вернуться назад и перейти на другие страницы сервиса.'
        break
      default:
        this.name = 'Неизвестная ошибка'
    }
  },

  methods: {
    redirect (errorCode) {
      if (errorCode === '403') { this.$router.go(-2) } else if (errorCode === '404') { this.$router.go(-1) } else { this.$router.go(-1) }
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('page-not-found')
  }
}
</script>
